import { render } from "./logOut.vue?vue&type=template&id=5b720f71&scoped=true"
import script from "./logOut.vue?vue&type=script&lang=js"
export * from "./logOut.vue?vue&type=script&lang=js"

import "./logOut.vue?vue&type=style&index=0&id=5b720f71&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b720f71"]])

export default __exports__